import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { Product } from 'src/app/modals/product.model';
import {  SwiperDirective } from 'ngx-swiper-wrapper';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { ProductDialogComponent } from '../../products/product-dialog/product-dialog.component';
import { CartService } from 'src/app/components/shared/services/cart.service';
import { ProductService } from 'src/app/components/shared/services/product.service';
import { WishlistService } from 'src/app/components/shared/services/wishlist.service';
import { SharedMethods } from 'src/app/components/shared/services/sharedMethods-service';
import { ProductDetailsComponent } from '../../products/product-details/product-details.component';

@Component({
  selector: 'app-product-carousel',
  templateUrl: './product-carousel.component.html',
  styleUrls: ['./product-carousel.component.scss']
})
export class ProductCarouselComponent implements OnInit {
  @Output() onOpenProductDialog: EventEmitter<any> = new EventEmitter();
  @Input('product') product: Array<Product> = [];
  public config: SwiperConfigInterface = {};
  // tslint:disable-next-line:max-line-length
  constructor(private dialog: MatDialog, private router: Router, private cartService: CartService, public productService: ProductService, private wishlistService: WishlistService, public sharedMethods: SharedMethods) { }

  ngOnInit() {
  }
  ngAfterViewInit(){
    this.config = {
      observer: true,
      slidesPerView: 5,
      spaceBetween: 16,
      keyboard: true,
      navigation: true,
      pagination: false,
      grabCursor: true,
      loop: false,
      autoplay: {
        delay: 1000,
        disableOnInteraction: true,
        reverseDirection: false,
      },
      speed: 1000,
      preloadImages: true,
      lazy: true,
      breakpoints: {
        480: {
          slidesPerView: 2
        },
        740: {
          slidesPerView: 2,
        },
        960: {
          slidesPerView: 3,
        },
        1280: {
          slidesPerView: 4,
        },


      }
    }
  }


  /* public openProductDialog(product){
  

    let dialogRef = this.dialog.open(ProductDetailsComponent, {
        data: product,
        panelClass: 'fullscreen-dialog',
        maxWidth: '100vw',
        width: '100vw',
        height: '100vh',
    });

    dialogRef.componentInstance.productId = product.id;
    dialogRef.componentInstance.dialogRef = dialogRef;


    if ( product.linkvideo !== null && product.linkvideo !== undefined ) {
      const tabDate = product.linkvideo.split('/');
      const tab = tabDate[3].split('?');
      dialogRef.componentInstance.linkvideo = tab[0];
      console.log(tab[0]);

      // return new Date(date).toISOString;
    }


  } */

  public openProductDialog(product){
    let dialogRef = this.dialog.open(ProductDialogComponent, {
        data: product,
        panelClass: 'product-dialog',
    });
    /* dialogRef.afterClosed().subscribe(product => {
      if(product){
        this.router.navigate(['/products', product.id, product.name]);
      }
    }); */
  }

   // Add to cart
   public addToCart(product: Product,  quantity: number = 1) {
    this.cartService.addToCart(product,quantity);
    console.log(product, quantity);
  }

   // Add to wishlist
   public addToWishlist(product: Product) {
    this.wishlistService.addToWishlist(product);
 }

    // Add to compare
    public addToCompare(product: Product) {
      this.productService.addToCompare(product);
   }
}
